export default __webpack_public_path__ + "static/media/YAS0010.34I-27781_-16672_0.60534f96.jpg";